import { Text, View } from "../Base";

import KeyValue from "./KeyValue";
import React from "react";
import SectionLabel from "./SectionLabel";
import clsx from "clsx";
import { formatMinutesToHHMM } from "../../utils/date";
import { makeStyles } from "@mui/styles";
import { padZeros } from "../../utils/routes";
import { palette } from "../../theme/palette";
import { selectedOverlaySelector } from "../../reducers/matrixProfile/selectors";
import { useSelector } from "react-redux";

const useStyles = makeStyles(({ typography }) => ({
  list: {
    overflow: "auto",
    marginRight: "-14px",
  },
  item: {
    marginTop: typography.pxToRem(2),
  },
  section: {
    marginTop: typography.pxToRem(2),
    display: "flex",
    flexDirection: "row",
    background: palette.typography.white.neutral,
    padding: "0.625rem",
    paddingBottom: "0.5rem",
    cursor: "default",
    color: "white",
  },
  content: {
    display: "flex",
    flexDirection: "row",
  },
  left: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  right: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
  },
  contentLeft: {
    display: "flex",
    flex: "1 0 45%",
    flexDirection: "column",
    alignItems: "center",
  },
  contentRight: {
    flex: "1 0 55%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
  },
  header: {
    height: "1.25rem",
    fontSize: "18px",
    lineHeight: "24px",
    textTransform: "uppercase",
  },
  subheader: {
    lineHeight: "20px",
    fontSize: "14px",
  },
  smName: {
    marginTop: "7px",
  },
}));

const SectionItem = ({ section }) => {
  const styles = useStyles();
  const selectedOverlay = useSelector(selectedOverlaySelector);

  return (
    <View className={styles.section}>
      <View className={styles.left}>
        <SectionLabel section={section} />
      </View>
      <View className={styles.right}>
        <Text className={styles.header} data-testid="section-name">
          {section.sectionName}
        </Text>
        <Text
          className={clsx(styles.subheader, styles.smName)}
          data-testid="section-name"
        >
          {section.shiftManagerName}
        </Text>

        <View className={styles.content}>
          <View className={styles.contentLeft}>
            <Text className={styles.subheader} data-testid="section-name">
              Routes
            </Text>
            <KeyValue
              property={"Total"}
              value={padZeros(section.totalRoutes, 3)}
            />

            {section.waves.map((wave) => (
              <KeyValue
                key={wave.waveName}
                property={`Wave ${wave.waveName}`}
                value={padZeros(wave.totalRoutes, 3)}
              />
            ))}

            <KeyValue
              property={"Unallocated"}
              value={padZeros(section.totalUnallocated, 3)}
            />
          </View>
          <View className={styles.contentRight}>
            {selectedOverlay && (
              <View>
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Stops"}
                  value={padZeros(section.totalStops, 3)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Parcels"}
                  value={padZeros(section.totalParcels, 3)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Collections"}
                  value={padZeros(section.totalCollections, 3)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Exceptions"}
                  value={`${padZeros(
                    section.routesWithExceptions,
                    3
                  )}(${padZeros(section.totalExceptions, 3)})`}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"SPR"}
                  value={padZeros(section.totalSPR, 3)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"Duty"}
                  value={formatMinutesToHHMM(section.totalAverageDutyTime)}
                />
                <KeyValue
                  leftSize={1}
                  rightSize={1}
                  property={"OT"}
                  value={formatMinutesToHHMM(
                    section.totalAverageOpportunityMinutes
                  )}
                />
              </View>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default SectionItem;
